<template>
  <!-- # 5.3.4	相同发行人债券 -->
  <el-container class="main_container w100">
    <el-main :class="{'ismobilePhone':isMobilePhone}">
      <div class="DataModule full_height">
        <el-row style="overflow-y: auto; height:100%;">
          <!-- Revised on 2022-03-05 -->
          <el-table
            id="table"
            :data="table_data"
            border
            style="width: 100%"
            height="100%"
            stripe
            fit
            :header-cell-style="{textAlign: 'center'}"
          >
            <!-- Revised on 2022-03-05 -->
            <el-table-column
              prop=a1
              align="center"
              :label=row_keys.a1
            />
            <el-table-column
              prop=a2
              align="center"
              :label=row_keys.a2
            />
            <el-table-column
              prop=a3
              align="center"
              :label=row_keys.a3
            />
            <!-- <el-table-column prop=a4    align="center"  :label=row_keys.a4 /> -->
            <!-- <el-table-column prop=a5    align="center"  :label=row_keys.a5 /> -->
            <el-table-column
              prop=a6
              align="center"
              :label=row_keys.a6
            />
            <!-- <el-table-column prop=a7    align="center"  :label=row_keys.a7 /> -->
            <!-- <el-table-column prop=a8    align="center"  :label=row_keys.a8 /> -->
            <el-table-column
              prop=a9
              align="center"
              :label=row_keys.a9
            />
            <!-- <el-table-column prop=b0    align="center"  :label=row_keys.b0 /> -->
            <el-table-column
              prop=b1
              align="center"
              :label=row_keys.b1
            />
          </el-table>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_same_issuer } from 'common/js/http/v3Api'
import { exportTableData } from 'common/js/utils/utils'

export default {
  name: "same_issuer",
  data() {
    return {
      row_keys: {
        // "a0":"日期",
        // "a1":"代偿期(年)",
        // "a2":"息票类型",
        // "a3":"估价全价",
        // "a4":"",
        // "a5":"估价净值",
        // "a6":"估价收益率",
        // "a7":"估价修正久期",
        // "a8":"估价凸性",
        // "a9":"交易市场",
        // "b0":"可信度",
        // "b1":"可信度代码(排序用)"
        "a0": "date",
        "a1": "Compensation period (year)",
        "a2": "Coupon type",
        "a3": "Full appraisal price",
        "a5": "Valuation net value",
        "a6": "Appraisal yield",
        "a7": "Valuation amendment duration",
        "a8": "Convexity of valuation",
        "a9": "Trading market",
        "b0": "reliability",
        "b1": ""
      },
      isMobilePhone: false,
      stockCode: '120303.SH',
      table_data: null
    };
  },

  mounted() {
    this.stockCode = this.$route.query.stockCode
    this.get_same_issuer()
  },
  methods: {
    async get_same_issuer() {
      const { data } = await get_same_issuer({
        trd_code: this.stockCode,
      });
      const rows = data.result.data[0].rows;
      this.table_data = rows
    },
    async searchTableData(item) {
      if (item) {
        this.stockCode = item;
        this.get_same_issuer()
      }
    },
    /* Revised on 2022-03-05 */
    exportTableData() {
      let html = document.getElementById("table").outerHTML.replace(/<(\w+) (.+?)>/g, (m, p1) => `<${p1}>`)
        .replace('<table>', '<table border>')
      // vnd.ms-excel.numberformat:@; 格式化文本
      // xmlns 和 head 中 用于显示网格线
      html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel">
            <head>
              <xml>
                <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                      <x:WorksheetOptions>
                        <x:Print><x:ValidPrinterInfo /></x:Print>
                      </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
                </x:ExcelWorkbook>
              </xml>
            </head>
            <style>
              table{vnd.ms-excel.numberformat:@;}
            </style>
              ${html}
            </html>`
      let blob = new Blob([html], { type: 'application/octet-stream' })
      let url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'same_issuer.xlsx' // 重命名文件
      link.click()
      window.URL.revokeObjectURL(url) // 释放内存
    }
    /* Revised on 2022-03-05 */
  }
};
</script>

<style scoped>
.ismobilePhone {
  padding: 0 !important;
  background: #fff !important;
}
.bgw {
  background: #fff;
}
.w100 {
  width: 100%;
}
.el-main {
  padding: 0;
  height: 100%;
}

table {
  height: calc(100% - 30px);
  width: 100%;
  padding: 10px 0;
}
tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}
tr:nth-of-type(even) {
  background-color: #ffffff;
}
td {
  text-indent: 10px;
  word-wrap: break-word !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: ellipsis;
  border: 0;
  border-right: 1px solid #cacaca;
  height: 32px;
}
.w20 {
  width: 20%;
}
.w80 {
  width: 80%;
}
</style>
